import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { useCloneProductById } from 'products-ui-components/hooks/useCloneProductById';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Raven from 'raven-js';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { ProductsTracker } from './utils/trackers';
import { jsx as _jsx } from "react/jsx-runtime";
const trackCreateProduct = modifiedPropertyNames => {
  CrmLogger.log('indexInteractions', {
    action: 'create product',
    subaction: `clone`
  });
  ProductsTracker.track('productPanelUsage', {
    action: `Clone product`,
    subAction: 'Save',
    propertyName: modifiedPropertyNames.join()
  });
};
const openPreviewPanelAction = objectId => ({
  type: 'OPEN_PANEL',
  payload: {
    panelType: 'PREVIEW_PANEL',
    panelData: {
      objectId,
      objectTypeId: PRODUCT_TYPE_ID
    }
  }
});
const onError = err => {
  Raven.captureException(err);
};
function ProductHighlightCloneButton({
  objectId,
  onObjectCreate
}) {
  const dispatch = useDispatch();
  const onClone = useCallback((newObjectId, modifiedPropertyNames) => {
    onObjectCreate({
      associationType: PRODUCT_TYPE_ID,
      objectId: newObjectId
    });
    trackCreateProduct(modifiedPropertyNames);
    dispatch(openPreviewPanelAction(newObjectId));
  }, [dispatch, onObjectCreate]);
  const {
    handleClone,
    isLoading
  } = useCloneProductById({
    objectId,
    onClone,
    onError
  });
  return /*#__PURE__*/_jsx(UIButton, {
    use: "tertiary-light",
    onClick: handleClone,
    "data-test-id": "clone-product-button",
    disabled: isLoading,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "actions.clone"
    })
  });
}
export default ProductHighlightCloneButton;